/* =====================================================================
 * CNM Cost Calculator — interactive slider
 * Vanilla JS, no dependencies. Recomputes "you vs dentist" cost on every
 * input event. Animates bars via CSS width transition.
 * ===================================================================== */

(function () {
  'use strict';

  function initCalc(root) {
    const dentistCost     = parseFloat(root.dataset.dentistCost || '380');
    const replaceYears    = parseFloat(root.dataset.dentistReplaceYears || '2');
    const cnmYearly       = parseFloat(root.dataset.cnmYearly || '45');

    const slider          = root.querySelector('[data-cnm-slider]');
    const yearsLabel      = root.querySelector('[data-cnm-years]');
    const yearsUnit       = root.querySelector('[data-cnm-years-unit]');
    const dentistTotalEl  = root.querySelector('[data-cnm-dentist-total]');
    const dentistSubEl    = root.querySelector('[data-cnm-dentist-sub]');
    const cnmTotalEl      = root.querySelector('[data-cnm-cnm-total]');
    const cnmSubEl        = root.querySelector('[data-cnm-cnm-sub]');
    const dentistBar      = root.querySelector('[data-cnm-bar-dentist]');
    const cnmBar          = root.querySelector('[data-cnm-bar-cnm]');
    const savingsEl       = root.querySelector('[data-cnm-savings]');
    const savingsSubEl    = root.querySelector('[data-cnm-savings-sub]');

    if (!slider) return;

    function format(n) {
      // Format with thousands separator
      return Math.round(n).toLocaleString('en-GB');
    }

    function recalc() {
      const years          = parseInt(slider.value, 10) || 1;
      const dentistGuards  = Math.ceil(years / replaceYears);
      const dentistTotal   = dentistGuards * dentistCost;
      const cnmTotal       = years * cnmYearly;
      const savings        = Math.max(0, dentistTotal - cnmTotal);
      const maxTotal       = Math.max(dentistTotal, cnmTotal, 1);

      // Year label
      if (yearsLabel) yearsLabel.textContent = years;
      if (yearsUnit)  yearsUnit.textContent  = years === 1 ? 'year' : 'years';

      // Totals
      if (dentistTotalEl) dentistTotalEl.textContent = format(dentistTotal);
      if (cnmTotalEl)     cnmTotalEl.textContent     = format(cnmTotal);
      if (savingsEl)      savingsEl.textContent      = format(savings);

      // Sub text
      if (dentistSubEl) {
        dentistSubEl.textContent = dentistGuards + '× £' + format(dentistCost) + ' every ' + replaceYears + ' yr';
      }
      if (cnmSubEl) {
        cnmSubEl.textContent = years + '× annual 3-pack';
      }
      if (savingsSubEl) {
        savingsSubEl.textContent = 'over ' + years + ' ' + (years === 1 ? 'year' : 'years') + ' of nightly grinding.';
      }

      // Bar widths (proportional to max of the two)
      const dentistPct = Math.max(8, (dentistTotal / maxTotal) * 100);
      const cnmPct     = Math.max(8, (cnmTotal     / maxTotal) * 100);
      if (dentistBar) dentistBar.style.width = dentistPct + '%';
      if (cnmBar)     cnmBar.style.width     = cnmPct + '%';
    }

    slider.addEventListener('input', recalc);
    recalc();
  }

  function initAll() {
    document.querySelectorAll('[data-cnm-calc]').forEach(initCalc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialise in theme editor
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-cnm-calc]');
    if (root) initCalc(root);
  });
})();
